<div class="insights-page">
    <div>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="page-sub-header">
            <div>
                <label class="page-header-title">Welcome!</label>
            </div>
            <div *ngIf="botListArray.length > 0 ">
                <button type="button" fxLayoutAlign="center center" class="create-bot-btn" fxFlex
                    [routerLink]="'/bots/create-bot'" [disabled]="!apiKeyIsGenerated">
                    <mat-icon>add</mat-icon> Add new Bot
                </button>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" style="margin:12px 45px;">
            <div class="jumbotron" style="width: 100%;">
                <div class="container" style="width: 100%;padding-right: 0;padding-left: 0;">
                    <app-alert></app-alert>
                </div>
            </div>
        </div>
        <div class="container" *ngIf="botListArray.length > 0" style="max-width:100%">
            <div class="row px-5 custom-scrollbar" >
                <mat-card class="col-md-6 custom-card" style="border: 1px solid #ECECEC;border-radius: 12px;width: 48%;box-shadow: none;">
                    <mat-card-content style="display: flex;align-items: center;">
                        <div class="IC_circle" [style.--p1]="userICpercentage" [style.--p2]="businessICpercentage" >
                            {{userIC + businessIC}}
                        </div>
                        <div style="width: 80%;" class="px-2">
                            <div class="left-card-content">
                                <div class = "responsive-font-size-12px responsive-width">All conversations</div>
                                <div style="flex:1;"></div>
                                <div class = "responsive-font-size-12px">{{userIC + businessIC}}</div>
                            </div>
                            <div style="padding-left: 4%;padding-right: 3%;">
                                <div style="border-bottom: 1px solid #E1E9FE;"></div>
                            </div>
                            <div class="left-card-content-below">
                                <div class="responsive-font-size-10px py-1 col-md-5"><svg width="19" height="4" viewBox="0 0 19 4" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="19" height="4" rx="2" fill="#386AF6" />
                                    </svg> Business IC <Span style="font-weight:bold ; float: right;">{{businessIC}}</Span>
                                </div>
                                <div style="flex:1;"></div>
                                <div class="responsive-font-size-10px py-1 col-md-5"><svg width="19" height="4" viewBox="0 0 19 4" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="19" height="4" rx="2" fill="#66EE8C" />
                                    </svg> User IC <Span style="font-weight:bold ;float: right;">{{userIC}}</Span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <!-- <mat-card class="col-md-6 custom-card" style="border: 1px solid #ECECEC;border-radius: 12px;width: 48%;box-shadow: none;">
                    <mat-card-content style="display: flex;align-items: center;">
                        <div class="IC_circle" [style.--p1]="userICpercentage" [style.--p2]="businessICpercentage" >
                            {{userIC + businessIC}}
                        </div>
                        <div style="width: 80%;" class="px-2">
                            <div class="left-card-content">
                                <div class = "responsive-font-size-12px responsive-width">All conversations</div>
                                <div style="flex:1;"></div>
                                <div class = "responsive-font-size-12px">{{userIC + businessIC}}</div>
                            </div>
                            <div style="padding-left: 4%;padding-right: 3%;">
                                <div style="border-bottom: 1px solid #E1E9FE;"></div>
                            </div>
                            <div class="left-card-content-below">
                                <div class="responsive-font-size-10px py-1 col-md-5"><svg width="19" height="4" viewBox="0 0 19 4" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="19" height="4" rx="2" fill="#386AF6" />
                                    </svg> Business IC <Span style="font-weight:bold ; float: right;">{{businessIC}}</Span>
                                </div>
                                <div style="flex:1;"></div>
                                <div class="responsive-font-size-10px py-1 col-md-5"><svg width="19" height="4" viewBox="0 0 19 4" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="19" height="4" rx="2" fill="#66EE8C" />
                                    </svg> User IC <Span style="font-weight:bold ;float: right;">{{userIC}}</Span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card> -->
            </div>
            <div class="w3-content w3-display-container py-2">
                <div class="w3-center w3-container w3-section w3-large w3-text-white w3-display-bottommiddle hidden-xl" style="width:100%; text-align: center;">
                  <span [class]="(slideIndex===1)?'w3-badge demo w3-border w3-transparent mx-1 w3-hover-white': 'w3-badge demo w3-border w3-transparent mx-1'" (click)="currentSlide(1)"></span>
                  <span [class]="(slideIndex===2)?'w3-badge demo w3-border w3-transparent mx-1 w3-hover-white': 'w3-badge demo w3-border w3-transparent mx-1'" (click)="currentSlide(2)"></span>
                </div>
            </div>
            <div class="container mb-3" style="max-width: 100%;">
                <div class="row px-4 responsive-padding-none">
                    <div class="col-md-12 responsive-padding-none">
                        <div class="card px-3 mb-2">
                            <div class="card-body">
                                <div class="row my-2">
                                    <div class="col-md-2 py-2 responsive-width-auto">
                                        <div ngbDropdown class="d-inline-block" style="min-width: 80%;">
                                            <button type="button" class="btn btn-outline-primary selectpicker" id="dropdownBasic1" ngbDropdownToggle
                                                style="flex-direction: row;padding:9px">{{dropdown_botname}}
                                                <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end" *ngIf="!dropdown_icon">keyboard_arrow_down</mat-icon>
                                                <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end" *ngIf="dropdown_icon">keyboard_arrow_up</mat-icon>
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="overflow: auto;max-height: 40vh;" class="custom_scrollbar">
                                                <button ngbDropdownItem *ngFor="let bots of botListArray" style="font-size: 12px;" class = "py-2"
                                                    (click)="getConversations(bots.bot_id, filterdt);botSelected = bots.bot_id;dropdown_botname = bots.name ">{{bots.name}}</button>
                                            </div>
                                        </div>

                                        <!-- <select #botSelected class="selectpicker"
                                            (change)="getConversations($event, filterdt)">
                                            <option *ngFor="let bots of botListArray" [value]="bots.bot_id">
                                                {{bots.name}}</option>
                                        </select> -->
                                    </div>
                                    <div class="col-md-4 py-2 hidden-sm"></div>
                                    <div class="col-md-6 justify-content-end btn-group hidden-sm ">
                                        <button class="btn mx-2 filter-btn col-md-3" type="button" style="overflow: hidden;"
                                            (click)="filterdt='yesterday';getConversations(botSelected, 'yesterday')">
                                            <span>Yesterday</span>
                                        </button>
                                        <button class="btn mx-2 filter-btn col-md-3" type="button" style="overflow: hidden;"
                                            (click)="filterdt='week';getConversations(botSelected, 'week')">
                                            <span>Last 7 days</span>
                                        </button>
                                        <button class="btn mx-2 filter-btn col-md-3 active" type="button" style="overflow: hidden;"
                                            (click)="filterdt='month';getConversations(botSelected, 'month')">
                                            <span>This month</span>
                                        </button>
                                        <!-- <button class="btn mx-2 filter-btn col-md-3" id="reportrange" type="button" style="overflow: hidden;"
                                            (change)="filterdt='custom';getConversations(botSelected, 'custom')">
                                            <span>Customize</span>
                                        </button> -->
                                        <mat-form-field appearance="standard" class = "custom-mat-form-field">
                                            <button class="btn mx-1 filter-btn col-md-3" style="display:inline-flex;justify-content: center;width: 100%" id="reportrange" type="button" (click)="rangePicker.open()" >
                                                <span>Customize</span>
                                                <span>
                                                    <mat-icon  *ngIf = "!dropdown_icon">keyboard_arrow_down</mat-icon>
                                                    <mat-icon  *ngIf = "dropdown_icon">keyboard_arrow_up</mat-icon>
                                                </span>
                                            </button>
                                            <mat-date-range-input [rangePicker]="rangePicker" hidden>
                                              <input matStartDate placeholder="Start date" [(ngModel)] ="custom_from_date">
                                              <input matEndDate placeholder="End date" [(ngModel)]="custom_to_date">
                                            </mat-date-range-input>
                                            <mat-datepicker-toggle matSuffix [for]="rangePicker" hidden></mat-datepicker-toggle>
                                            <mat-date-range-picker #rangePicker (opened)="iconChange()" (closed)="iconChange()">
                                              <mat-date-range-picker-actions>
                                                <button mat-button matDateRangePickerCancel style="
                                                border: 1px solid #386AF6;
                                                border-radius: 50px;
                                                color: #386AF6;
                                                width: 40%;
                                            ">Cancel</button>
                                                <button mat-raised-button (click)="updateCustomDate()" color="primary" matDateRangePickerApply style="
                                                background: #386AF6;
                                                border-radius: 50px;
                                                width: 40%;
                                                margin-left: 6%;
                                            ">Update</button>
                                              </mat-date-range-picker-actions>
                                            </mat-date-range-picker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6 py-2 justify-content-end btn-group hidden-gt-md " style="width:50%">
                                        <div class=" first-content-field normal-text" >
                                            <div ngbDropdown class="d-inline-block">
                                                <button type="button" class="btn btn-outline-primary selectpicker" id="dropdownBasic1" ngbDropdownToggle
                                                    style="flex-direction: row;padding:9px;border:none">{{dropdown_filter}}
                                                    <mat-icon style="margin-left: 5%;color: #386AF6;" *ngIf="!dropdown_icon">keyboard_arrow_down</mat-icon>
                                                    <mat-icon style="margin-left: 5%;color: #386AF6;" *ngIf="dropdown_icon">keyboard_arrow_up</mat-icon>
                                                </button>
                                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" >
                                                <button class = "py-2" ngbDropdownItem style="font-size: 12px;"(click)="getConversations(botSelected, 'yesterday');dropdown_filter = 'Yesterday' " >Yesterday</button>
                                                <button class = "py-2" ngbDropdownItem style="font-size: 12px;"(click)="getConversations(botSelected, 'week');dropdown_filter = 'Last 7 days' " >Last 7 days</button>
                                                <button class = "py-2" ngbDropdownItem style="font-size: 12px;"(click)="getConversations(botSelected, 'month');dropdown_filter = 'This month' " >This month</button>
                                                <button class = "py-2" ngbDropdownItem style="font-size: 12px;"(click)="dropdown_filter = 'Customize';rangePicker.open()" >Customize</button>
                                                </div>
                                            </div>
                                            <mat-date-range-input [rangePicker]="rangePicker" hidden>
                                                <input matStartDate placeholder="Start date" [(ngModel)] ="custom_from_date">
                                                <input matEndDate placeholder="End date" [(ngModel)]="custom_to_date">
                                              </mat-date-range-input>
                                              <mat-datepicker-toggle matSuffix [for]="rangePicker" hidden></mat-datepicker-toggle>
                                              <mat-date-range-picker touchUi="true" #rangePicker (opened)="iconChange()" (closed)="iconChange()">
                                                <mat-date-range-picker-actions>
                                                  <button mat-button matDateRangePickerCancel style="
                                                  border: 1px solid #386AF6;
                                                  border-radius: 50px;
                                                  color: #386AF6;
                                                  width: 40%;
                                              ">Cancel</button>
                                                  <button mat-raised-button (click)="updateCustomDate()" color="primary" matDateRangePickerApply style="
                                                  background: #386AF6;
                                                  border-radius: 50px;
                                                  width: 40%;
                                                  margin-left: 6%;
                                              ">Update</button>
                                                </mat-date-range-picker-actions>
                                              </mat-date-range-picker>
                                            <!-- <select #botSelected class="selectpicker" style="border:none" (change)="getConversations(botSelected.value,$event)">
                                                <option value = 'yesterday'>Yesterday</option>
                                                <option value = 'week'>Last 7 days</option>
                                                <option value = 'month'>This month</option>
                                                <option value = 'custom' id="reportrange"><button class="btn mx-2 filter-btn col-md-3" id="reportrange" type="button">
                                                    <span>Customize</span>
                                                </button></option>
                                            </select> -->
                                        </div>
                                    </div>
                                    <div class="py-2">
                                        <div style="background: #FFFFFF;border: 1px solid #ECECEC;"></div>
                                    </div>
                                    <div class="row hidden-sm">
                                        <div class="py-2" style="flex: 0 0 auto;width: 3.33333333%;">
                                            <label class="switch">
                                                <input type="checkbox" checked (change)="hideOne($event, 0)">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                        <div class="col-md-3 py-1">
                                            <label>
                                                <span style="font-size: 12px;letter-spacing: 0.002em;">User initiated
                                                    conversations</span>
                                            </label>
                                        </div>
                                        <div class="py-2" style="flex: 0 0 auto;width: 3.33333333%;">
                                            <label class="switch">
                                                <input type="checkbox" checked (change)="hideOne($event, 1)">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                        <div class="col-md-3 py-1">
                                            <label>
                                                <span style="font-size: 12px;letter-spacing: 0.002em;">Business initiated
                                                    conversations</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row hidden-xl">
                                        <div class="d-flex" fxLayout="row-reverse" fxLayoutAlign="space-between center">
                                            <div class="py-2">
                                                <label class="switch">
                                                    <input type="checkbox" checked (change)="hideOne($event, 0)">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div class="col-md-3 py-1" style="width: auto;padding: 2%;">
                                                <label>
                                                    <span style="font-size: 12px;letter-spacing: 0.002em;">User initiated
                                                        conversations</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-flex" fxLayout="row-reverse" fxLayoutAlign="space-between center">
                                            <div class="py-2" >
                                                <label class="switch">
                                                    <input type="checkbox" checked (change)="hideOne($event, 1)">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div class="col-md-3 py-1" style="width: auto;padding: 2%;">
                                                <label>
                                                    <span style="font-size: 12px;letter-spacing: 0.002em;">Business initiated
                                                        conversations</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="mapArray && mapArray.length > 0" style="padding-right:0 !important;padding-left:0!important">
                                        <app-am-line-chart [reportType]="'DAILY'" [mapData]="mapArray" [userIC]="U_IC"
                                            [businessIC]="B_IC" [min]="min" [max]="max"></app-am-line-chart>
                                    </div>
                                    <div class="d-flex justify-content-center bd-highlight mb-3"
                                        *ngIf="mapArray && mapArray.length == 0"
                                        style="padding-top: 10rem!important;padding-bottom: 10rem!important;">
                                        <div class="bd-highlight" style="    font-family: 'Montserrat';
                                        font-style: normal;
                                        letter-spacing: 0.02em;
                                        color: #999999;
                                        font-weight: 500;
                                        font-size: 14px;
                                        line-height: 15px;">No Conversations found. Try changing filter date</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row" style="padding:12px;margin:-2% 0% 3% 0%" *ngIf="showKycStatusBar && !kycDocumentsUploaded">
        <div fxLayout="row" class="progress-section">
            <div fxLayout="row" fxLayoutGap="15" fxFlex="67">
                <div fxLayout="column">
                    <div class="basic-container">
                        <svg style="position:absolute" width="42" height="42" viewBox="0 0 42 42" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle opacity="0.08" cx="21" cy="21" r="21" fill="#EB5757" />
                        </svg>
                        <mat-progress-spinner strokeWidth="2.5" [diameter]="42" color="primary" mode="determinate"
                            value="0">
                        </mat-progress-spinner>
                        <img src="assets/kyc-status-img.svg" class="progress-img" />
                    </div>
                </div>
                <div fxLayoutAlign="start center">
                    <label>Complete your KYC to generate API Key</label>
                </div>

            </div>

            <div fxLayout="row" fxFlex="30" fxLayoutAlign="space-between center">
                <div fxLayout="row">

                    <label>KYC Status</label>
                </div>
                <div class="divider"></div>
                <label>Incomplete KYC</label>
                <div class="divider"></div>
                <a [routerLink]="'/business-documents'">
                    Complete Now
                </a>

            </div>
        </div>
    </div>
    <div fxLayout="row" *ngIf="showKycStatusBar && kycDocumentsUploaded">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="verify-kyc-section">
            <div fxLayout="row" fxLayoutGap="25">
                <div>
                    <img src="assets/approval-pending.svg" />
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" class="verify-pending">
                    <label>
                        Your KYC approval is pending. It will take 2-3 working days for your documents to get verified.
                    </label>
                </div>
            </div>
        </div>

    </div>
    <div fxLayout="row" class="kyc-reject-section" *ngIf="loginUserDetails?.status == 'REJECTED'">
        <div fxLayout="row" fxLayoutGap="15" fxFlex="67">
            <div fxLayout="column">
                <div class="basic-container">
                    <svg style="position:absolute" width="42" height="42" viewBox="0 0 42 42" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.08" cx="21" cy="21" r="21" fill="#EB5757" />
                    </svg>
                    <mat-progress-spinner strokeWidth="2.5" [diameter]="42" color="primary" mode="determinate"
                        value="0">
                    </mat-progress-spinner>
                    <img src="assets/kyc-status-img.svg" class="progress-img" />
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5">
                <label class="reject-reason">Your KYC has been rejected</label>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5">
                    <h5 class="reject-kyc-reason">Reason for Rejection:</h5>
                    <h5 class="reject-reason"> {{loginUserDetails.status_reason}}</h5>
                </div>

            </div>
        </div>
        <div fxLayout="row" fxFlex="30" fxLayoutAlign="end center">
        
            <a [routerLink]="'/business-documents'" class="update-kyc">
                Update KYC Documents 
            </a>
            <mat-icon class="resend-btn">chevron_right</mat-icon>
        
        </div>


    </div>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img"
        *ngIf="apiKeyIsGenerated && botListArray.length == 0 ">
        <img src="../../assets/mesage-main.svg" />
        <label class="createBot-label">Create and Add your bots to start your journey now</label>
        <button fxLayoutAlign="center center" type="button" class="btn add btn-primary createBot-btn"
              [routerLink]="'/bots/create-bot'">Create Bot</button>
        <label class="terms-label">&nbsp;By clicking on Create now, you agree to the <a class="terms-conditions"
                (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-bot-api-integration-terms/')">Terms
                & Conditions</a> of SwiftChat Bot creation</label>

    </div>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img"
        *ngIf="apiKeyIsGenerated == false && botListArray.length == 0 ">
        <img src="../../assets/mesage-main.svg" />
        <label class="col-xl-3 sub-label" fxLayoutAlign="center center">Generate API Key to create and add your bots to start
            your journey now</label>
        <button fxLayoutAlign="center center" type="button" class="btn add btn-primary generateAPI-btn"
            (click)="openApiGenerateKeyPopup()" style="border-radius: 18px;cursor: pointer;width:280px"
            [disabled]="showKycStatusBar || loginUserDetails?.status == 'REJECTED' ">Generate
            API Key</button>

    </div>
</div>